module.exports = __webpack_public_path__ + "481a29389c138aa9e012dfaa5e58f2d8.png";